import { h } from 'preact'
import { useState, useEffect, useCallback } from "preact/hooks";

// tslint:disable: typedef

export function useEditor<T>(initialData: T) {
    const [data, setData] = useState(initialData);
    const handleInputChange = useCallback((event: any) => { // todo: proper type for event
        // event.persist();

        var val = event.target?.value;

        if (event.target.nodeName === "INPUT" && event.target.type === "number") {
            val = parseInt("" + val, 10);
        }
        if (event.target.nodeName === "INPUT" && (event.target.type === "datetime-local" || event.target.type === "date")) {
            val = !!event.target.value ? new Date(event.target.value) : undefined;
        }
        setData(data => ({ ...data, [event.target.name]: val }));
    }, [data, setData]);
    useEffect(() => {
        setData(initialData);
    }, [initialData]);
    return {
        data,
        setData,
        handleInputChange
    };
}